module.exports = __webpack_public_path__ + "img/home_slider_04.46408840.jpg";